import { fetchWithDefaults } from '../config/fetchDefault';
import { setLoadingGif } from '../features/loadingSlice';
import { setProducts, setReccomendations } from '../features/productRecommendationSlice'

// Create an AbortController instance
let productAbortController = new AbortController()
let quoteAbortController = new AbortController()

const runVM = async (profile, leadId, dispatch, agentId) => {
    try {
        // cancel existing request first
        productAbortController.abort('[Funnel-runVM] Canceling stale request')

        // re-initialize abortContoller
        productAbortController = new AbortController()

        const profilePayload = {...profile}

        if(!profilePayload.borrower_sex){
            profilePayload.borrower_sex = 'Male'
        }

        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({
                leadId:leadId,
                profile: profilePayload,
                agent: agentId
            }),
            signal: productAbortController.signal
        };

        dispatch(setProducts([]))
        cancelQuoteRequest()
        dispatch(setReccomendations([]))

        const response = await fetchWithDefaults('/virtualMentor/products', requestOptions);

        if (!response.ok) {
            return false;
        }
        const jsonData = await response.json();

        if(jsonData){
            dispatch(setProducts(jsonData.data))

            const initialReccomendations = []

            for (let index = 0; index < jsonData.data.length; index++) {
                const product = jsonData.data[index];

                initialReccomendations.push({
                    quote: null,
                    tempId: product.uid+profile.faceAmount+'tl_'+profile.term,
                    ...product
                })
            }

            dispatch(setReccomendations(initialReccomendations))
        }
    }
    catch (error) {
        dispatch(setProducts([]))
        dispatch(setReccomendations([]))
        console.error("Error fetching data:", error);
        return false;
    }
};
const handleSelectedProducts=(faceAmount, product, setSelectedProducts)=>{
    setSelectedProducts((prevItems) => {
        const exists = prevItems.some(item => item.product.tempId === product.tempId);

        if (exists) {
          // Remove the item if it exists
          return prevItems.filter(item => item.product.tempId !== product.tempId);
        } else {
          // Add the item if it doesn't exist
          return [...prevItems, { face: faceAmount, product }];
        }
    });
}

const runVMMed = async (medication, setMedications, agentId) => {
    try {
        const response = await fetchWithDefaults(`/virtualMentor/medication/${medication}?agent=${agentId}`);

        if (!response.ok) {
            return false;
        }

        const medications = await response.json()

        // return medications
        setMedications(medications)
    }
    catch (error) {
        console.error("Error fetching data:", error);
        return false;
    }
}

const determineHealthRating = (tobaccoUse = 'no', rateClass = 'S') => {
    let prefix = rateClass
    let suffix = tobaccoUse === 'yes' ? 'T': 'NT'

    let rating = `${prefix}${suffix}`

    // SPT and PPT are not a valid health rating in Navigator
    if(rating === 'PPT'){
        rating = 'PT'
    }

    if(rating === 'SPT'){
        rating = 'ST'
    }

    return rating
}

const sendLeadToNavigator = async (agentCode, agentEmail, leadCode, age, sex, dispatch, agentId) => {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
            agent: agentId,
            agentCode,
            agentEmail,
            leadCode,
            age,
            sex,
        })
    };
    try {
        dispatch(setLoadingGif(true));
        const response = await fetchWithDefaults('/virtualMentor/sendToNavigator', requestOptions);

        if (!response.ok) {
            dispatch(setLoadingGif(false));
            return null
        }

        const jsonData = await response.json();
        const navRedirectData = {...jsonData.data.data}
        dispatch(setLoadingGif(false));

        return navRedirectData.startQuoteUrl ?? null
    } catch (error) {
        console.error("Error fetching data:", error);
        dispatch(setLoadingGif(false));
        return null;
    }
}

const getQuotesForProducts = async (productData, profile, agentId) => {
    if(productData.length === 0 || !!!profile.faceAmount || !!!profile.state || (!!!profile.borrower_age && !!!(new Date(profile.borrower_dob)).getDate()) || !!!profile.tobacco){
        return []
    }

    const products = productData.map(p =>  p.uid)
    try {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({
                faceAmount: profile.faceAmount,
                state: profile.state,
                age: profile.borrower_age,
                borrower_sex: profile.borrower_sex ?? 'Male',
                product_option: profile.productOption,
                term: profile.term,
                borrower_dob: profile.borrower_dob,
                tobacco: profile.tobacco,
                healthRating: profile.healthRating,
                weight: profile.weight,
                feet: profile.feet,
                inches: profile.inches,
                qualifiers: profile.qualifiers,
                products,
                agent: agentId,
            }),
            signal: quoteAbortController.signal
        };

        const response = await fetchWithDefaults('/virtualMentor/quote', requestOptions)

        if (!response.ok) {
            return [];
        }
        const jsonData = await response.json()
        return jsonData.data
    } catch (error) {
        return []
    }
}

const cancelProductRequest = () => {
    productAbortController.abort('[cancelProductRequest] - Canceling previous product request')

    // re-initialize abortContoller
    productAbortController = new AbortController()
}

const cancelQuoteRequest = () => {
    quoteAbortController.abort('[cancelQuoteRequest] - Canceling previous quote request')

    // re-initialize abortContoller
    quoteAbortController = new AbortController()
}

const tobaccoRatings = ['ST','PT']
const nonTobaccoRatings = ['PPNT','PNT','SPNT','SNT']
const healthRatingPrefix = {
    'ST': 'S',
    'SNT': 'S',
    'SPNT': 'SP',
    'PT': 'P',
    'PNT': 'P',
    'PPNT': 'PP',
}

export {runVM, runVMMed, handleSelectedProducts, determineHealthRating, sendLeadToNavigator, getQuotesForProducts, cancelProductRequest, cancelQuoteRequest, tobaccoRatings, nonTobaccoRatings, healthRatingPrefix };
